import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';


export default class CloseOutWorked extends Component {
  
  static propTypes = {

  };

  state = {
  };

  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Lesson Learned: What worked well?
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              style={{width: '100%'}}
              multiline
              rows="4"
              margin="normal"
              id="scope_worked"
              name="scope_worked"
              label="Scope"
              fullWidth
              autoComplete="scope_worked"
              value={this.props.closeout.scope_worked}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.scope_worked}
              helperText={this.props.errores.scope_worked}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              style={{width: '100%'}}
              multiline
              rows="4"
              margin="normal"
              id="schedule_worked"
              name="schedule_worked"
              label="Schedule"
              fullWidth
              autoComplete="schedule_worked"
              value={this.props.closeout.schedule_worked}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.schedule_worked}
              helperText={this.props.errores.schedule_worked}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              style={{width: '100%'}}
              multiline
              rows="4"
              margin="normal"
              id="cost_worked"
              name="cost_worked"
              label="Cost"
              fullWidth
              autoComplete="cost_worked"
              value={this.props.closeout.cost_worked}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.cost_worked}
              helperText={this.props.errores.cost_worked}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              style={{width: '100%'}}
              multiline
              rows="4"
              margin="normal"
              id="other_worked"
              name="other_worked"
              label="Other"
              fullWidth
              autoComplete="other_worked"
              value={this.props.closeout.other_worked}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.other_worked}
              helperText={this.props.errores.other_worked}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/CloseOutWorked.js